import React from "react"
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import Navbar from "./Navbar"
import Menu from "./Menu"
import Footer from "./Footer"
import { FloatButton } from 'antd'
// import { loadLiveChat } from '@/utils/liveChat';
// import { loadJekka } from '@/utils/jekka';
import { loadAiLiveChat } from '@/utils/aiLiveChat';
import { loadGtm } from '@/utils/gtm';
import { loadMatomo } from "@/utils/matomo";
import { loadForter } from "@/utils/forter";
import UvpBanner from "./UvpBanner";
import { abTestCalculate } from "@/utils/ABtest";

import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain

interface LayoutProps {
  children: React.ReactNode;
  wideScreen?: boolean;  // 是否使用宽屏
  notStickyNavbar?: boolean; // 是否取消Navbar吸顶效果
}

export default function DefaultLayout(props: LayoutProps) {
  const router = useRouter();

   useEffect(() => {
    // 加载AB测试逻辑
    abTestCalculate("")
  }, [])

  useEffect(() => {
    function handleWindowLoad() {
      // 排除详情页，加载LiveChat
      // if (!router.pathname.includes('/product-detail/')) {
      //   loadLiveChat();
      // }
      // loadJekka();
      loadAiLiveChat();
      loadMatomo();
      loadGtm();
      loadForter();
    }

    if (document.readyState === 'complete') {
      loadAiLiveChat();
    } else {
      window.addEventListener('load', handleWindowLoad);
    }

    return () => {
      window.removeEventListener('load', handleWindowLoad);
    };
  }, []);

  return (
    <div style={router.pathname === '/' ? {
      backgroundImage: `url('${imageDomain}/christmas-theme/web-container-bg.jpg')`,
      backgroundColor: '#f5f5f5',
      backgroundRepeat: 'repeat',
      backgroundPosition: 'center'
    } : { background: '#f5f5f5' }}>
      <Navbar
        wideScreen={props.wideScreen}
        useChristmasTheme={!router.pathname.includes('/my-account')}
        sticky={props.notStickyNavbar ? true : false}
      />
      <UvpBanner wideScreen={props.wideScreen} />
      <Menu
        wideScreen={props.wideScreen}
        useChristmasTheme={!router.pathname.includes('/my-account')}
      />

      <main style={{ background: '#F5F5F5' }}>{props.children}</main>

      <Footer />
      <FloatButton.BackTop />
    </div>
  )
}
